// extracted by mini-css-extract-plugin
export var container = "PlaybackControls-module--container--de09b";
export var controlButton = "PlaybackControls-module--controlButton--0f8dc";